import type {
    SecurityAuditAgeGroup,
    SecurityAuditDuplicitiesGroup,
    SecurityAuditLeaksGroup,
    SecurityAuditLevelGroup,
} from '@/modules/secrets';
import { isSecurityAuditAgeGroup, isSecurityAuditLeaksGroup, isSecurityAuditLevelGroup } from '@/modules/secrets/utilities';

export const getGroupMessageId = (
    item: SecurityAuditAgeGroup | SecurityAuditLevelGroup | SecurityAuditLeaksGroup | SecurityAuditDuplicitiesGroup,
) => {
    if (isSecurityAuditLevelGroup(item)) {
        return `securityAudit.report.level.${item.securityLevel}` as const;
    } else if (isSecurityAuditAgeGroup(item)) {
        return `securityAudit.report.age.${item.securityAge}` as const;
    } else if (isSecurityAuditLeaksGroup(item)) {
        return `securityAudit.report.leaks.${item.securityLeaks}` as const;
    }
    return 'securityAudit.report.duplicities';
};
